import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Grid } from "@material-ui/core";
import { ContentText } from "../../text/content-text";

const useStyles = makeStyles((theme: Theme) => ({
  bullet: {
    marginRight: theme.spacing(3),
  },
}));

interface IBulletTextProps {}

export const BulletText: FunctionComponent<IBulletTextProps> = (props) => {
  const { children } = props;
  const classes = useStyles();
  return (
    <ContentText small light>
      <Grid container wrap={"nowrap"}>
        <Grid item>
          <span className={classes.bullet}>&#8226;</span>
        </Grid>
        <Grid item xs>
          {children}
        </Grid>
      </Grid>
    </ContentText>
  );
};
